import {commitMutation, graphql} from 'react-relay';
import Util from '../forecast-app/shared/util/util';

const mutation = graphql`
	mutation updateTicketingProfileMutation($input: UpdateTicketingProfileInput!) {
		updateTicketingProfile(input: $input) {
			clientMutationId
			user {
				id
				emailSignature
			}
		}
	}
`;

function getConfigs() {
	return [];
}

// The profile fields are read off the Viewer (`ticketingEmailSignature` /
// `ticketingReplyToEmail`), but the payload returns an AccountUser — which
// exposes no Reply-To field at all. Nothing in the response can refresh those
// viewer scalars, so write the values that were just saved onto them directly;
// otherwise a revisit without a network refetch renders stale values.
// Only fields present in `input` are written, so a single-field save never
// clobbers its sibling.
function updateViewerProfileFields(store, input) {
	const viewer = store.getRoot().getLinkedRecord('viewer');
	if (!viewer) return;

	if (input.emailSignature !== undefined) {
		viewer.setValue(input.emailSignature, 'ticketingEmailSignature');
	}
	if (input.replyToEmail !== undefined) {
		viewer.setValue(input.replyToEmail, 'ticketingReplyToEmail');
	}
}

function commit(environment, input, onSuccess, onError) {
	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		configs: getConfigs(),
		updater: store => updateViewerProfileFields(store, input),
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
